import React from 'react'
import styled from 'styled-components'
import DefaultLayout from '../../components/DefaultLayout'
import { StyledHome } from "./components/StyledHome"
import { Link } from "./components/Link"

const Wrapper = styled.div`
    
`

const Home = () => {
    return (
        <DefaultLayout>
            <StyledHome>
                <Link href={"/"}>
                    Man
                </Link>
                <Link href={"/"}>
                    Women
                </Link>
            </StyledHome>
        </DefaultLayout>
    )
}

export default Home

